import { Component, OnInit, OnDestroy, Input,AfterViewInit,ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute } from '@angular/router';
import { ExtraInfoService } from '../../../_services/index';
import { AuthenticationService } from '../../../_services/index';

@Component({
  selector: 'app-extracurricullar-activities',
  templateUrl: './extracurricullar-activities.component.html',
  styleUrls: ['./extracurricullar-activities.component.css'],
  providers:[ExtraInfoService]
  
})
export class ExtracurricullarActivitiesComponent implements OnInit, OnDestroy {

  date: any[] = [ /\d/, /\d/,'-', /\d/, /\d/,'-', /\d/, /\d/, /\d/, /\d/];

  extraForm: FormGroup;
  formChangeSub: Subscription;
  getdataSub: Subscription;
  submitdataSub: Subscription;
  formValueChangeSub: Subscription;
  
  error: boolean;
  errorFlag: boolean;
  successMessage: string;
  errorMessage: string;
  submitBtnText = '';
  submitting: boolean;
  fieldErrors:any;
  
  public personalEmail: string;
  currentUser:any;
  loading: boolean;
  public checkChange = false;
  public valueChange = false;
  public canDeactivateCheck = false;
  public checkingSubmit = false;
  public checkboxes = [];
  public checkboxesArray = [];
  public showBelow = false;
  public isRequired = false;
  isCNIC = true;
  showlegalresi = false;
  showlegaldischarged= false;
  constructor(
    private _fb: FormBuilder,
    private router: Router,
    public api: ExtraInfoService,
    private cdr: ChangeDetectorRef,private loginservice: AuthenticationService,
    
  ) { }

  /* ngAfterViewInit() {
    this.cdr.detectChanges();
  } */

  ngOnInit() {
    
    //this.getAcademicInfo();

    this.checkboxes = [
                  {'Name':'Community Service or Volunteering','isChosen': false,'year':'','role':'','hidden': true,'required': null},
                  {'Name':'Athletics','isChosen': false,'year':'','role':'','hidden': true,'required': null},
                  {'Name':'Arts','isChosen': false,'year':'','role':'','hidden': true,'required': null},
                  {'Name':'School Organization or Club','isChosen': false,'year':'','role':'','hidden': true,'required': null},
                  {'Name':'Major Award or Honor','isChosen': false,'year':'','role':'','hidden': true,'required': null},
                  {'Name':'College Readiness Program','isChosen': false,'year':'','role':'','hidden': true,'required': null},
                  {'Name':'Foreign Travel or Study','isChosen': false,'year':'','role':'','hidden': true,'required': null},
                  {'Name':'Home and Family Responsibilities','isChosen': false,'year':'','role':'','hidden': true,'required': null},
                  {'Name':'Government','isChosen': false,'year':'','role':'','hidden': true,'required': null},
                  {'Name':'Internship','isChosen': false,'year':'','role':'','hidden': true,'required': null},
                  {'Name':'Military','isChosen': false,'year':'','role':'','hidden': true,'required': null},
                  {'Name':'Other Activity','isChosen': false,'year':'','role':'','hidden': true,'required': null},
/*                   {'Name':'None','isChosen': true,'year':'','role':'','hidden': true,'required': null}
 */                ];
    //console.log(this.checkboxes);
    
    
    for (let checkbox of this.checkboxes) {
      this.checkboxesArray.push(this._fb.group({
        isChosen: checkbox.isChosen,
        name: checkbox.Name,
        typeArray:this._fb.array([ this.createType() ]),
        hidden: checkbox.hidden,
        //required: checkbox.required

      }));
    }

    //console.log(this.checkboxesArray);
    
    this.createForm();

    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.personalEmail=this.currentUser?this.currentUser.email:'';
    this.extraForm.get('personalEmail').setValue(this.personalEmail);

    this.getExtraInfo();
    window.scrollTo(300, 500)
    this.checkCinc();
  }

  ngOnDestroy() {
    
    if (this.formChangeSub) {
      this.formChangeSub.unsubscribe();
    }
    if (this.getdataSub)  {
      this.getdataSub.unsubscribe();
    }
    if (this.submitdataSub)  {
      this.submitdataSub.unsubscribe();
    }
    if (this.formValueChangeSub)  {
      this.formValueChangeSub.unsubscribe();
    }
    
  }

  private _onValueChanged() {
    //console.log(this.checkChange);
    //console.log(this.extraForm.value.none)
    
    if(this.checkChange)
    {
      //console.log(this);
      //console.log('aca');
      this.valueChange = true

    }
        
  }

  createType() {
    return this._fb.group({
      type: [''],
      year: [''],
      role: [''],
    });
  }

  addType(i: number) {
    console.log(i);
    //console.log(this.extraForm.controls['involved']['controls'][i].controls['typeArray']);
    const control = <FormArray>this.extraForm.controls['involved']['controls'][i].controls['typeArray'];
    control.push(this.createType());
  }

  deleteType(i: number,x: number) {
    //console.log(this.extraForm.controls['involved']['controls'][i].controls['typeArray']);
    const control = <FormArray>this.extraForm.controls['involved']['controls'][i].controls['typeArray'];
    control.removeAt(x);
  }

  createForm() {

    let formControlArray = new FormArray(this.checkboxesArray);

    this.extraForm  = this._fb.group({
      personalEmail: ['', [Validators.required]],
      involved: formControlArray,
      none: [''],
      selectedItems: new FormControl(this.mapItems(formControlArray.value), Validators.required),    
      militarystatus:[''],
      militarymembercurrently:[''],
      assignmentincalifornia:[''],
      stateoflegal:[''],
      homeofrecord:[''],
      dateofdischarge:[''],
      typeofdischarge:[''],
      stateoflegaldischarged:[''],
      homeofrecorddischarged:[''],
    });

    console.log(this.extraForm);

    this.formChangeSub = this.extraForm
    .valueChanges
    .subscribe(data => this._onValueChanged());
    this._onValueChanged();

    this.formValueChangeSub = formControlArray.valueChanges.subscribe((v) => {
      console.log(this.mapItems(v));
      this.extraForm.controls.selectedItems.setValue(this.mapItems(v));
    });

   /*  this.formValueChangeSub = formControlArray.valueChanges.subscribe((v) => {
      //console.log(v);
      this.extraForm.controls.selectedItems.setValue(this.mapItems(v));
    }); */
    
  }

  mapItems(items) {
   
    //console.log(items);

    let selectedItems = items.filter(x => x.isChosen);
    
    //console.log(selectedItems.length);

    return selectedItems.length ? selectedItems : null;
  }

  onCheckChange() {
    
    let items = this.extraForm.value;

    //console.log(items.involved)

    let length = items.involved.filter(x => x.isChosen).length;
    
    console.log(length);

    items.involved.filter(x => x.name).map(x => {

        if(x.isChosen)
        {
          console.log(x.name);
            x.hidden = false;
            //x.required = true;
            
        } else {

            x.hidden = true;

            x.typeArray.filter(xx => xx.year).map(xx => {

              xx.year = '';
              xx.role = '';
              xx.type = '';
            
            });
            //x.required = false;
            //x.year = '';
            //x.role = '';
            
        }

    });

    //console.log(items.involved);

    this.extraForm.controls['involved'].setValue(items.involved);
    
    if(length>0)
    {
      this.extraForm.controls['none'].setValue(0);
      
      //this.extraForm.controls.none.disable(); 
      
    }
    else{
      //this.extraForm.controls.none.enable(); 
      this.extraForm.controls['none'].setValue(1);
      //console.log(this.extraForm.controls.none);
      this.extraForm.controls.selectedItems.setValue(1);
      //console.log(this.extraForm.controls.selectedItems.value);
    }
    
  }

  onCheckNone() {

    let noneCheck = this.extraForm.controls.none.value;
   // console.log(noneCheck);
  
    let items = this.extraForm.value;
    
   // console.log(items.involved)
    items.involved.filter(x => x.name).map(x => {
      
      //console.log(x.name);
      x.isChosen = false;
      x.hidden = true;
      //x.required = false;
      //x.year = '';
      //x.role = '';
      
    });

    //console.log(items.involved)

    this.extraForm.controls['involved'].setValue(items.involved);
    
    //console.log(this.extraForm.controls.selectedItems.value);

    //console.log(this.extraForm.value.involved)
    if(noneCheck)
    {
      //this.extraForm.controls.involved.disable(); 
      this.extraForm.controls.selectedItems.setValue(this.extraForm.controls.none);
    }
    else{
      //this.extraForm.controls.involved.enable(); 
      this.extraForm.controls.selectedItems.setValue('');
    }

    //console.log(this.extraForm.controls.selectedItems.value);
    
  }


  /* onCheckNoneGet() {
    
    let noneCheck = this.extraForm.controls.none.value;
    console.log(noneCheck);
        
  } */

  showVal() {

    let items = this.extraForm.value;

    //console.log(items)

    let length = items.involved.filter(x => x.isChosen).length;

    items.involved.filter(x => x.isChosen).map(x => {
        
        /* x.hidden = false;
        x.required = null; */
        if(x.name == 'None')
        {
          
          x.hidden = true;
          //x.required = null;
        }
        else{
          x.hidden = false;
          //x.required = true;
          
        }
      });
  }

  onSubmit() {

    this.loading = true;

    const body = JSON.stringify({

      personalEmail: this.extraForm.controls.personalEmail.value,
      /* howmanyyears: this.extraForm.controls.howmanyyears.value,
      whatrole: this.extraForm.controls.whatrole.value, */
      involved: JSON.stringify( this.extraForm.controls.involved.value ),
      none: this.extraForm.controls.none.value,
      militarystatus: this.extraForm.controls.militarystatus.value,
      militarymembercurrently: this.extraForm.controls.militarymembercurrently.value,
      assignmentincalifornia: this.extraForm.controls.assignmentincalifornia.value,
      stateoflegal: this.extraForm.controls.stateoflegal.value,
      homeofrecord: this.extraForm.controls.homeofrecord.value,
      dateofdischarge: this.extraForm.controls.dateofdischarge.value,
      typeofdischarge: this.extraForm.controls.typeofdischarge.value,
      stateoflegaldischarged: this.extraForm.controls.stateoflegaldischarged.value,
      homeofrecorddischarged: this.extraForm.controls.homeofrecorddischarged.value,
    });

    //console.log(body);
    //console.log(this.extraForm.controls.none);
    this.submitting = true;
    this.api.postExtraInfo$(body)
      .subscribe(
        data => {
          this.error = false;
          this.submitting = false;
          
            this.errorFlag = false;
            const response = JSON.parse(data._body);
            
            this.successMessage = response.message;
            this.loading = false;
            if(!this.canDeactivateCheck)
            {
              this.checkingSubmit = true;
              if( response.errorFields == 0 )
              {
                this.router.navigate(['/profile/employment']);
              }
              else{
                this.errorFlag = true;
                this.errorMessage = 'Please fill all fields.';
                window.scrollTo(300, 500)
                
              }
            }
            
        },
        error => {
          this.submitting = false;
          this.errorFlag = true;
          const errordata = JSON.parse(error._body);
          if (errordata.success === 0) {
            this.errorMessage = errordata.message;
            this.errorFlag = true;
            this.fieldErrors = errordata.errors;
            this.loading = false;
          }
        },
      );
  }

  getExtraInfo() {

    this.loading = true;
    const body = JSON.stringify({
          email: this.personalEmail
    });

    this.getdataSub = this.api.getExtraInfo(body)
    
      .subscribe(responsedata => {
          //console.log(responsedata.data);
          let extraInfodata = responsedata.data;
          //console.log(backgroundInfodata);
          let involved = JSON.parse(extraInfodata.involved);
          
          //console.log(involved);

          this.extraForm.controls['none'].setValue(extraInfodata.involve_none);
          
          /* this.extraForm.controls['whatrole'].setValue(extraInfodata.what_role);
          this.extraForm.controls['howmanyyears'].setValue(extraInfodata.how_many_years); */
          //console.log(JSON.parse(academicInfodata.carrer_sectors.json()));
          if(involved)
          {
           
            let i = 0;
            involved.forEach(item => {
              //console.log(item.typeArray)
              
              let x = 0;

              //console.log(item.typeArray.length);

              if(item.typeArray.length > 1)
              {

                
                for(var ii = 2; ii <= item.typeArray.length; ii++){
                 //console.log(ii);
                  const control = <FormArray>this.extraForm.controls['involved']['controls'][i].controls['typeArray'];
                  control.push(this.createType());
                  x++
                }
                
              }
              
              //console.log(this.extraForm.controls['involved']['controls'][i].controls['typeArray']);
              i++
            });
            
            this.extraForm.controls['involved'].setValue(involved);

            /* if (typeof involved.typeArray !== 'undefined') {
              const phoneLength = personalInfodata.phones.length;
              for (let i = 1; i < phoneLength; i++) {
                this.addPhone();
              }
              this.profileForm.controls['phones'].setValue(personalInfodata.phones);
            } */

            this.onCheckChange();
            
          }
          //console.log(this.extraForm.controls.none.value);
          if(this.extraForm.controls.none.value)
          {
            this.extraForm.controls.selectedItems.setValue(this.extraForm.controls.none);
          }
          
          if(extraInfodata.militarystatus){

            this.onSelect(extraInfodata.militarystatus);

            this.extraForm.controls['militarystatus'].setValue(extraInfodata.militarystatus);

          }

          if(extraInfodata.militarymembercurrently){
            this.extraForm.controls['militarymembercurrently'].setValue(extraInfodata.militarymembercurrently);

          }

          if(extraInfodata.assignmentincalifornia){
            this.extraForm.controls['assignmentincalifornia'].setValue(extraInfodata.assignmentincalifornia);

          }

          if(extraInfodata.stateoflegal){
            this.extraForm.controls['stateoflegal'].setValue(extraInfodata.stateoflegal);

          }

          if(extraInfodata.homeofrecord){
            this.extraForm.controls['homeofrecord'].setValue(extraInfodata.homeofrecord);

          }

          if(extraInfodata.dateofdischarge){
            this.extraForm.controls['dateofdischarge'].setValue(extraInfodata.dateofdischarge);

          }

          if(extraInfodata.typeofdischarge){
            this.extraForm.controls['typeofdischarge'].setValue(extraInfodata.typeofdischarge);

          }

          if(extraInfodata.stateoflegaldischarged){
            this.extraForm.controls['stateoflegaldischarged'].setValue(extraInfodata.stateoflegaldischarged);

          }

          if(extraInfodata.homeofrecorddischarged){
            this.extraForm.controls['homeofrecorddischarged'].setValue(extraInfodata.homeofrecorddischarged);

          }

          this.loading = false;
          setTimeout(()=>{

            this.checkChange = true;
          
          },2000);
 
        });

  }

  canDeactivate() {
    
    if(this.valueChange  && this.checkingSubmit == false)
    {
      if(confirm("Want to save changes?")) {
          
        this.canDeactivateCheck = true;
        this.onSubmit();
        
      }
    }
    
    return true;
        
  }

  onSelect(event){

    const getDomainName = this.loginservice.getDomainName();
    const parts = window.location.hostname.split(getDomainName);
    //const countLength = parts.length;
    const subdomain = parts.shift();
    console.log(subdomain);
    if(subdomain == 'cinc'){

      //const newVal = event.target.value;
      console.log(this.extraForm);
      console.log(event);
      if(event == 'I am currently serving on active duty' || event == 'My Parents/Guardian/Spouse is currently serving on active duty' || event == 'I am a member of the Active Reserve' || event == 'I am a member of the National Guard'){
        this.showlegalresi = true;
        this.showlegaldischarged = false;
      }
      else if(event == 'I served in the U.S. Military (Veteran)' || event == 'My Parents/Guardian/Spouse served in the U.S.Military (Veteran)'){
        this.showlegaldischarged = true;
        this.showlegalresi = false;
      }
      else{
        this.showlegalresi = false;
        this.showlegaldischarged = false;

      }
    }
  }

  checkCinc(){
    const getDomainName = this.loginservice.getDomainName();
    const parts = window.location.hostname.split(getDomainName);
    //const countLength = parts.length;
    const subdomain = parts.shift();
    console.log(subdomain);
    if(subdomain == 'cinc'){
        this.isCNIC = true;
        this.onSelect('I am currently serving on active duty');
    }
    else{
        this.isCNIC = false;
    }
  }

}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/profile/extracurricullar-activities/extracurricullar-activities.component.ts